import React, { useState } from "react";


import AOPCalculationRules from "./AOPCalculationRules";
import AOPForm from "./AOPForm";
import AOPEligibilityConstraints from "./AOPEligibilityConstraints";
import AopCpSignOffStep4 from "./AopCpSignOffStep4";
import PopExclusions from "./PopExclusions";
import AOPReviewConfiguration from "./AOPReviewConfiguration";
const CreateAopWizard = () => {
  const [activeStep, setActiveStep] = useState(0);

  /* ------------------- AOP FORM STATE ------------------- */
  const [formData, setFormData] = useState({
    /* Step 1 */
    aopName: "",
    financialYear: "",
    description: "",
    isActive: true,
      validityStartDate: null,
  validityEndDate: null,
    scopeType: "ALL",
  excludedProjects: [],
  cpScopeType: "ALL", // "ALL" or "SPECIFIC"
selectedCPs: [],

    /* Step 2 */
    scopeType: "all",
    projectIds: [],
    regionIds: [],
    cpTypes: [],

    /* Step 3 */
    targetBasis: "revenue",
    targetSlabs: [{ from: "", to: "", incentive: "" }],

    /* Step 4 */
    incentiveType: "percentage",
    paymentTrigger: "agreement",

    /* Step 5 */
    eligibility: {
      siteVisitEnabled: false,
      siteVisitMin: "",
      fosEnabled: false,
      fosMin: "",
      dealsEnabled: false,
      dealsMin: "",
    },

    conflictStrategy: "highest",
  });

  /* ------------------- STEP RENDERING ------------------- */
  return (
    <>
      {/* STEP 1 */}
      {activeStep === 0 && (
        <AOPForm
          data={formData}
          setData={setFormData}
          onNext={() => setActiveStep(1)}
        />
      )}

      {/* STEP 2 */}
      {activeStep === 1 && (
        <AOPCalculationRules
          data={formData}
          setData={setFormData}
          onBack={() => setActiveStep(0)}
          onNext={() => setActiveStep(2)}
        />
      )}
          {activeStep === 2 && (
        <AOPEligibilityConstraints
          data={formData}
          setData={setFormData}
          onBack={() => setActiveStep(1)}
          onNext={() => setActiveStep(3)}
        />
      )}
       {activeStep === 3 && (
        <AopCpSignOffStep4
          data={formData}
          setData={setFormData}
          onBack={() => setActiveStep(2)}
          onNext={() => setActiveStep(4)}
        />
      )}

        {activeStep === 4 && (
        <PopExclusions
          data={formData}
          setData={setFormData}
          onBack={() => setActiveStep(3)}
          onNext={() => setActiveStep(5)}
        />
      )}
      {activeStep === 5 && (
        <AOPReviewConfiguration
          data={formData}
          setData={setFormData}
          onBack={() => setActiveStep(4)}
          onNext={() => setActiveStep(0)}
        />
      )}
   
    </>
  );
};

export default CreateAopWizard;
